import React from 'react';
import { Box, Typography } from '@mui/material';
import TransactionReceipts from '../components/TransactionReceipts';
import CSVUpload from '../components/CsvUpload';
import BuchungskontenListe from '../components/BuchungskontenListe';

const Finanzen = () => {
  return (
    <div>
      <h1>Finanzen</h1>
      <p>Willkommen auf dem Finanzen!</p>

      <Box my={4}>
        <Typography variant="h6">
          Hier kannst du über eine .csv Datei deine Kontobewegungen hochladen. Wenn Betrag, Datum und Mandatsreferenz doppelt ist, wird der Datensatz übersprungen.
        </Typography>
        <CSVUpload />
      </Box>

      <Box my={4}>
        <Typography variant="h6">
          Für Bar-Transaktionen nutzen Sie die Kontobewegungsverwaltung im Dashboard.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Alle Transaktionsfunktionen wurden in die zentrale Kontobewegungsverwaltung integriert.
        </Typography>
      </Box>

      <Box my={4}>
        <Typography variant="h6">
          Hier möchte ich noch eine Abfrage einbauen, welche Belege doppelt sind d.h. Datum, Betrag.
          Und hier muss noch eine Uploadfunktion inklusive Verarbeitung in die Tabelle rein. Plus ein Modul um einzelne Zahlungen anzulegen.
        </Typography>
        <TransactionReceipts />
      </Box>  

      <Box my={4}>
        <Typography variant="h6">
            Hier stehen alle Buchungskonten
        </Typography>
        <BuchungskontenListe/>
      </Box>
    </div>
  );
};

export default Finanzen;
